<template>

  <div>
    <!-- <b-row
      class="content-header"
      style="flex-wrap: nowrap;"
    >
      <b-col
        class="content-header-left mb-2"
        md="9"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h2 class="custom-header-title float-left pr-1 mb-0">
              Customer Requests
            </h2>
          </b-col>
        </b-row>
      </b-col>
    </b-row> -->
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <b-col
            v-if="isMobile()"
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-space_between mb-1 mb-md-0"
          >
            <div class="bulk_selection d-flex">
              <div class="action-left pt-50">
                <b-form-checkbox
                  :checked="selectAllRequestCheckbox"
                  :indeterminate="isSelectAllRequestCheckboxIndeterminate"
                  @change="selectAllCheckboxUpdate"
                >
                  Select All
                </b-form-checkbox>
              </div>
              <b-button
                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                variant="primary"
                :disabled="!selectedRequests.length"
                @click="bulkApproveRequests"
              >
                Bulk Approve
              </b-button>
            </div>
            <span class="text-muted">Showing <br>{{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>
          <b-col
            v-else
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <div class="action-left pt-50">
              <b-form-checkbox
                :checked="selectAllRequestCheckbox"
                :indeterminate="isSelectAllRequestCheckboxIndeterminate"
                @change="selectAllCheckboxUpdate"
              >
                Select All
              </b-form-checkbox>
            </div>
            <b-button
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="primary"
              class="mx-50"
              :disabled="!selectedRequests.length"
              @click="bulkApproveRequests"
            >
              Bulk Approve
            </b-button>
            <span class="text-muted">Showing {{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search..."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = ''; showSearchBar = !showSearchBar"
                  />
                </b-input-group-append>
              </b-input-group>

              <b-dropdown
                id="dropdown-address-form"
                ref="filter_dropdown_requests"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <request-filters
                  :status-filter.sync="statusFilter"
                  :status-options="statusOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <div v-if="statusFilter.length">
          <hr class="dividerHR filter-divider">
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-for="statusVal in statusFilter"
                  :key="statusVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromStatusFilter(statusVal)"
                  >
                    <span class="text-capitalize">{{ statusVal }}</span>
                  </b-form-tag>
                </li>
                <li
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        ref="refCustomerProfileListTable"
        class="position-relative min-height-150"
        :items="fetchCustomerProfileLists"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(stringID)="data">
          <div class="text-nowrap">
            <b-form-checkbox
              :checked="selectedRequests.includes(data.item._id)"
              :disabled="data.item.status != 'awaiting approval'"
              @change="toggleSelectedRequests(data.item._id)"
              @click.native.stop
            >
              <b-button
                v-if="canViewThisAction('show', 'CustomerRequest')"
                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                variant="link"
                class="weight-600 align-middle detail-view-id"
                :to="{ name: 'app-customer-profile-update-view', params: { id: data.item._id } }"
              >
                {{ data.item.stringID }}
              </b-button>
              <b-button
                v-else
                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                variant="none"
                class="text-bold-black align-middle detail-view-id not-button"
              >
                {{ data.item.stringID }}
              </b-button>
            </b-form-checkbox>
          </div>
        </template>
        <template #cell(change)="data">
          <div class="">
            <b-table-simple
              borderless
              responsive
              class="particulars_of_deceased no-padding-table"
            >
              <b-tbody>
                <b-tr v-if="data.item.pendingArray.includes('Home Number')">
                  <b-td class="width-50">
                    <b-avatar
                      text="H"
                      variant="light-primary"
                    />
                  </b-td>
                  <b-td style="width: 300px;">
                    <del class="">{{ data.item.prevHomeTel }}</del>
                  </b-td>
                  <td class="width-50">
                    <feather-icon
                      icon="ArrowRightIcon"
                      size="18"
                      class="align-middle text-body"
                    />
                  </td>
                  <b-td>
                    <span class="">{{ data.item.homeTel }}</span>
                  </b-td>
                </b-tr>
                <b-tr v-if="data.item.pendingArray.includes('Residential Address')">
                  <b-td class="width-50">
                    <b-avatar
                      text="R"
                      variant="light-primary"
                    />
                  </b-td>
                  <b-td style="width: 300px;">
                    <del class="">{{ data.item.prevPerAdd1 }}, {{ data.item.prevPerAdd2 }}, {{ data.item.prevPerCountry }} {{ data.item.prevPerPostcode }}</del>
                  </b-td>
                  <td class="width-50">
                    <feather-icon
                      icon="ArrowRightIcon"
                      size="18"
                      class="align-middle text-body"
                    />
                  </td>
                  <b-td style="max-width: 250px;">
                    <span class="">{{ data.item.perAdd1 }}, {{ data.item.perAdd2 }}, {{ data.item.perCountry }} {{ data.item.perPostcode }}</span>
                  </b-td>
                </b-tr>
                <b-tr v-if="data.item.pendingArray.includes('Mailing Address')">
                  <b-td class="width-50">
                    <b-avatar
                      text="M"
                      variant="light-primary"
                    />
                  </b-td>
                  <b-td style="width: 300px;">
                    <del class="">{{ data.item.prevCorAdd1 }}, {{ data.item.prevCorAdd2 }}, {{ data.item.prevCorCountry }} {{ data.item.prevCorPostcode }}</del>
                  </b-td>
                  <td class="width-50">
                    <feather-icon
                      icon="ArrowRightIcon"
                      size="18"
                      class="align-middle text-body"
                    />
                  </td>
                  <b-td style="max-width: 250px;">
                    <span class="">{{ data.item.corAdd1 }}, {{ data.item.corAdd2 }}, {{ data.item.corCountry }} {{ data.item.corPostcode }}</span>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            :variant="`light-${resolveLogStatusVariant(data.item.status)}`"
            style="font-size: 14px; font-weight: 400;"
          >
            <span class="text-capitalize">{{ data.item.status }}</span>
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('show', 'CustomerRequest') || canViewThisAction('approve', 'CustomerRequest') || canViewThisAction('reject', 'CustomerRequest')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('show', 'CustomerRequest')"
              :to="{ name: 'app-customer-profile-update-view', params: { id: data.item._id } }"
            >
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canViewThisAction('approve', 'CustomerRequest') && data.item.status == 'awaiting approval'"
              @click="approveRequest(data.item._id)"
            >
              <span class="align-middle ml-50">Approve</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canViewThisAction('reject', 'CustomerRequest') && data.item.status == 'awaiting approval'"
              @click="rejectRequest(data.item._id, data.item.stringID)"
            >
              <span class="align-middle ml-50">Reject</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-card>

    <div
      v-if="totalChanges > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalChanges"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BInputGroup, BInputGroupAppend, BFormCheckbox, BButton, BAvatar,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormTag, BTableSimple, BTbody, BTr, BTd,
} from 'bootstrap-vue'
import { ref, onUnmounted, computed } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import useChangeList from './profileList'
import profileStoreModule from './profileStoreModule'
import RequestFilters from './RequestFilters.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BFormTag,
    BFormCheckbox,
    BButton,
    BTableSimple,
    BTbody,
    BTr,
    BTd,
    BAvatar,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    RequestFilters,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      user: store.state.auth.userData,
    }
  },

  methods: {
    hideFilter() {
      this.$refs.filter_dropdown_requests.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_requests.show(true)
    },
    removeFromStatusFilter(item) {
      const index = this.statusFilter.indexOf(item)
      if (index > -1) {
        this.statusFilter.splice(index, 1)
      }
    },

    clearAllFilters() {
      this.statusFilter = []
    },
    bulkApproveRequests() {
      this.$swal({
        title: 'Approve these Customer Requests?',
        html: 'You are going to approve these Customer Requests. Are you sure?',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/success.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, proceed!',
        cancelButtonText: 'No, go back',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            const formData = new FormData()
            formData.append('status', 'approved')
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < this.selectedRequests.length; i++) {
              formData.append('requests[]', this.selectedRequests[i])
            }

            this.$http.post('customer/customer/profile-change/approve/bulk', formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
              .then(() => {
                this.selectedRequests = []
                this.refetchData()
                this.$swal({
                  title: 'Change Approved',
                  html: '',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/success.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
    approveRequest(id) {
      this.$swal({
        title: 'Approve this Customer Request?',
        html: 'You are going to approve this Customer Request. Are you sure?',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/success.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, proceed',
        cancelButtonText: 'No, cancel',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            const formData = new FormData()
            formData.append('status', 'approved')

            this.$http.post(`customer/customer/profile-change/${id}/approve`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
              .then(() => {
                this.refetchData()
                this.$swal({
                  title: 'Change Approved',
                  html: '',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/success.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
    rejectRequest(id, stringID) {
      this.$swal({
        title: 'Are you sure you want to <br>reject this request?',
        html: `Once you reject this request <strong>${stringID}</strong>, <br>customer will be informed.`,
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/file-cross.png'),
        input: 'textarea',
        inputPlaceholder: 'Add Remarks',
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, reject request',
        cancelButtonText: 'No, go back',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
          input: 'reject-note-ta',
        },
        buttonsStyling: false,
        preConfirm: inputValue => {
          const textarea = this.$swal.getInput()
          const errorContainer = document.getElementById('swal-validation-error')

          if (!inputValue || inputValue.trim() === '') {
            textarea.classList.add('swal-input-error')
            if (!errorContainer) {
              const errorEl = document.createElement('small')
              errorEl.id = 'swal-validation-error'
              errorEl.innerText = 'Remarks are required to reject the request.'
              textarea.parentNode.appendChild(errorEl)
            }
            return false
          }

          // Cleanup if valid
          textarea.classList.remove('swal-input-error')
          if (errorContainer) errorContainer.remove()

          return inputValue
        },
        didOpen: () => {
          const textarea = this.$swal.getInput()
          textarea.classList.remove('swal-input-error')
        },
      })
        .then(result => {
          if (result.value) {
            const formData = new FormData()
            formData.append('status', 'rejected')
            formData.append('rejectNote', result.value)

            this.$http.post(`customer/customer/profile-change/${id}/approve`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
              .then(() => {
                this.refetchData()
                this.$swal({
                  title: 'Change Rejected',
                  html: `Request <strong>${stringID}</strong> has been rejected.`,
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/cross.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const CHANGE_LIST_APP_STORE_MODULE_NAME = 'app-profile-change-list'

    // Register module
    if (!store.hasModule(CHANGE_LIST_APP_STORE_MODULE_NAME)) store.registerModule(CHANGE_LIST_APP_STORE_MODULE_NAME, profileStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CHANGE_LIST_APP_STORE_MODULE_NAME)) store.unregisterModule(CHANGE_LIST_APP_STORE_MODULE_NAME)
    })

    const statusOptions = [
      { label: 'Approved', value: 'approved' },
      { label: 'Rejected', value: 'rejected' },
      { label: 'Awaiting Approval', value: 'awaiting approval' },
    ]

    const { canViewThisAction } = useAclUtils()

    const {
      fetchCustomerProfileLists,
      tableColumns,
      perPage,
      currentPage,
      totalChanges,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      requestData,
      isSortDirDesc,
      refCustomerProfileListTable,
      refetchData,

      toDeletedID,
      currentDataLength,
      statusFilter,

      // UI
      resolveLogStatusVariant,
    } = useChangeList()

    const selectedRequests = ref([])
    const toggleSelectedRequests = requestId => {
      const requestIndex = selectedRequests.value.indexOf(requestId)

      if (requestIndex === -1) selectedRequests.value.push(requestId)
      else selectedRequests.value.splice(requestIndex, 1)
    }
    const selectAllRequestCheckbox = computed(() => requestData.value.length && (requestData.value.length === selectedRequests.value.length))
    const isSelectAllRequestCheckboxIndeterminate = computed(() => Boolean(selectedRequests.value.length) && requestData.value.length !== selectedRequests.value.length)
    const selectAllCheckboxUpdate = val => {
      if (val) {
        selectedRequests.value = requestData.value.filter(r => r.status === 'awaiting approval').map(flow => flow._id)
      } else {
        selectedRequests.value = []
      }
      // selectedRequests.value = val ? requestData.value.map(flow => flow._id) : []
    }

    return {

      // Sidebar

      fetchCustomerProfileLists,
      tableColumns,
      perPage,
      currentPage,
      totalChanges,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refCustomerProfileListTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      toDeletedID,
      currentDataLength,
      requestData,

      // Filter
      avatarText,
      canViewThisAction,
      statusFilter,

      // UI
      resolveLogStatusVariant,

      statusOptions,

      selectAllRequestCheckbox,
      isSelectAllRequestCheckboxIndeterminate,
      selectedRequests,
      toggleSelectedRequests,
      selectAllCheckboxUpdate,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
